<template>
    <div class="g-page-layout">
        <div class="grin-container">
            <div v-if="heroImageUrl" class="campaign-view-image">
                <img :src="heroImageUrl" alt="campaign image" />
            </div>
            <header
                v-if="$slots.header"
                class="g-header"
                :class="{ 'g-header-padding': !disablePadding }"
                :style="headerStyle"
            >
                <slot name="header" />
            </header>
            <section class="g-content" :class="{ 'g-content-padding': !disablePadding }" :style="bodyStyle">
                <slot />
                <div v-if="readonly" class="transparent-mask"></div>
            </section>
        </div>
        <footer
            v-if="$slots.footer && !hideFooter"
            class="g-footer"
            :class="{ 'footer-shadow': footerBoxShadow, 'g-footer-padding': !disablePadding }"
        >
            <slot name="footer" />
        </footer>
    </div>
</template>

<script>
    import NavigationMenu from '../../../src/components/sections/NavigationMenu';
    import useFeatureFlagsStore from '../../../stores/feature-flags';

    export default {
        name: 'PageLayout',
        props: {
            showNav: {
                type: Boolean,
                default: false
            },
            heroImageUrl: {
                type: String,
                required: false
            },
            footerBoxShadow: {
                type: Boolean,
                default: true
            },
            disablePadding: {
                type: Boolean,
                default: false
            },
            headerStyle: {
                type: Object
            },
            bodyStyle: {
                type: Object
            },
            /**
             * Places transparent mask overlay on top of the content slot to block
             * interactions with the content. Use FloatOnMask wrapper component to
             * "float up" content elements above the mask.
             */
            readonly: {
                type: Boolean,
                default: false
            },

            /**
             * Whether the footer should be hidden
             */
            hideFooter: {
                type: Boolean,
                default: false
            }
        },
        components: {
            NavigationMenu
        },
        computed: {
            styles() {
                return {
                    backgroundImage: `url(${this.heroImageUrl})`
                };
            }
        },
        setup() {
            const FeatureFlag = useFeatureFlagsStore().data;

            return {
                FeatureFlag
            };
        }
    };
</script>

<style lang="scss" scoped>
    .g-page-layout {
        height: 100%;
        background-color: $g-color-white;
        display: flex;
        flex-direction: column;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15);
        .grin-container {
            position: relative;
            flex: 1;
            min-height: 0;
            overflow-y: auto;
        }

        .g-header {
            background-color: #D7D7E0;
            &.g-header-padding {
                padding: $g-spacing-6;
            }
        }

        .g-content {
            position: relative;
            &.g-content-padding {
                padding: $g-spacing-6;
            }

            & .transparent-mask {
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: rgba(0, 0, 0, 0);
                z-index: 1001;
            }
        }

        .g-footer {
            &.g-footer-padding {
                padding: $g-spacing-6;
            }

            &.footer-shadow {
                box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
            }
        }

        .campaign-view-image img {
            width: 100%;
        }
    }
</style>
